const wikiBoxInfoBoxItemType = {
    text: 'text',
    link: 'link',
    list: 'list',
};

export default wikiBoxInfoBoxItemType;
